/**
 * 中文 - 简体
 *
 */

export default {
  curlan:'zh-CN',
  
  common: {
    sotck_hk: '港股',
    sotck_us: '美股',
    sotck_A: 'A股',
    free: '免费',
    tips1: '保存失败',
    unopen: '未开户',
  },
  tuyere: {
    title: '热门股单',
    nodata: '暂无数据',
    down_refresh: {
      contentdown: '下拉刷新',
      contentover: '释放刷新',
      contentrefresh: '加载中...',
      contentsuccess: '刷新成功',
      contenterror: '刷新失败',
    },
    head: {
      txt_1: '股票名称',
      txt_2: '当前价',
      txt_3: '年初至今涨跌幅'
    },
    concept: {
      txt_1: '收起',
      txt_2: '还有{num}家公司，点击查看全部'
    },
    foot_1: '风险提示：以上数据来自第三方数据源，仅供参考，不构成投资建议。',
    foot_2: '行情资讯服务由富元犇犇提供',
    foot_3: '免责声明'
  },
  my_market: {
    title: '我的行情',
    active: '当前权限',
    buy: '购买',
    renew: '续期',
    lv1: {
      txt_1: '延时行情',
      txt_2: '实时行情手工刷新/无盘口数据',
      txt_2_1: '行情数据（报价、分时、K线等）延时15分钟，无经纪席位、盘口、成交明细。',      
      txt_3: '无盘口数据',
      txt_4: '免费',
      txt_5: 'LV1基础行情'
    },
    lv2: {
      txt_1: 'LV2实时行情',
      txt_2: '实时更新/10档盘口/10档经纪队列',
      txt_3: '实时行情实时更新/提供1档买卖盘口',
      txt_5: '剩余{day}天',
      txt_8: '实时',
      txt_9: '实时行情/提供5档买卖盘口',
      txt_11: '{money}港币/月',
      txt_12: '会员赠送',

    },
    warn_title:'温馨提示:',
    warn_desc:`1、普通会员将会免费赠送1次30天的L2行情；<br/>
    2、白银、黄金、铂金、钻石会员，会员存续期<br/>将一直免费赠送L2行情；`
  },
  intro_quota:{
    title: '我的行情',
    text_1:'自动更新',
    text_2:'买卖盘5档',
    text_3:'实时自动更新',
    text_4:'免费',
    text_5:'手工刷新',
    text_6:'买卖10档',
    text_7:'10-40档',
    text_8:'20只之外延时',
    text_10:'长期有效',
    text_11:'根据购买时长',
    text_12:'13HKD/月',
    text_13:'200HKD/月',
    text_14:'400HKD/月(含PC)',
    text_15:'2.99USD/月',
    text_16:'延时15分钟',
    text_17:'延时更新',
    text_18:'*注：BMP行情已下线。',
    hk:{
      text_1:'港股LV2行情',
      text_2:`实时更新/10档盘口/<br/>
      10档经纪队列`,
      text_3:'港股行情对比',
      table_txt1:'延时行情',
      table_txt2:'实时LV2',
      table_col1_txt1:'实时数据',
      table_col1_txt2:'推送',
      table_col1_txt3:'盘口数据',
      table_col1_txt4:'逐笔成交',
      table_col1_txt5:'经纪席位',
      table_col1_txt6:'行情列表',
      table_col1_txt7:'国内定价',
      table_col1_txt8:'海外定价',
      table_col1_txt9:'app+pc互通',
      table_col1_txt10:'到期日',
      text_4:'逐笔明细',
      text_5:'精确反映盘中交易变动，洞悉资金流入流出意图',
      text_6:'10档买卖盘委托',
      text_7:'把握股价的支撑阻力位，精准下单提高成交率',
      text_8:'买卖盘经纪商',
      text_9:'看清机构控盘行为及挂单量',
      


    },
    us:{
      text_1:'美股LV2行情',
      text_2:`实时行情/实时更新/<br/>
      提供1档买卖盘口`,
      text_3:'美股行情对比',
      table_txt1:'实时LV1',
      table_txt2:'实时LV2',
      table_col1_txt1:'实时数据',
      table_col1_txt2:'实时推送',
      table_col1_txt3:'盘口数据',
      table_col1_txt4:'逐笔成交',
      table_col1_txt5:'经纪席位',
      table_col1_txt6:'行情列表',
      table_col1_txt7:'定      价',
      table_col1_txt8:'app+pc互通',
      table_col1_txt9:'到期日',
      text_4:'逐笔明细',
      text_5:'精确反映盘中交易变动，洞悉资金流入流出意图',
      text_6:'1档买卖盘委托',
      text_7:'把握股价的支撑阻力位，精准下单提高成交率',
      text_8:'买卖盘经纪商',
      text_9:'看清机构控盘行为及挂单量',
    },
    cn:{
      text_1:'A股LV1行情',
      text_2:'实时行情/提供5档买卖盘口',
      text_3:'A股行情说明',
      table_txt1:'延时LV1',
      table_col1_txt1:'实时数据',
      table_col1_txt2:'实时推送',
      table_col1_txt3:'盘口数据',
      table_col1_txt4:'逐笔成交',
      table_col1_txt5:'经纪席位',
      table_col1_txt6:'行情列表',
      table_col1_txt7:'定      价',
      table_col1_txt8:'app+pc互通',
      text_4:'逐笔明细',
      text_5:'精确反映盘中交易变动，洞悉资金流入流出意图',
      text_6:'5档买卖盘委托',
      text_7:'把握股价的支撑阻力位，精准下单提高成交率',
      text_8:'买卖盘经纪商',
      text_9:'看清机构控盘行为及挂单量',
    },

  },
  how_to_invest_old: {
    title: '为什么投资港美股',
    name1: '投资全球顶尖港美上市公司',
    desc1: {
      text_1: '市场透明',
      text_2: '港美股市制度规范透明',
      text_3: '投资者权益保障更完善',
    },
    desc2: {
      text_1: 'T+0交易',
      text_2: '日内买卖，交易灵活',
    },
    desc3: {
      text_1: "无资金门槛",
      text_2: '无需50亿资金门槛',
    },
    desc4: {
      text_1: '标的丰富',
      text_2: '股票、ETF、基金及衍生品'
    },
    name2: '港股大新多重优势',
    advantage1: {
      text_1: '认购0门槛',
      text_2: '无帐户持仓市值要求',
      text_3: '存入新股预缴金即可打新',
    },
    advantage2: {
      text_1: '认购灵活',
      text_2: '可融资可现金申购',
      text_3: '灵活搞定港股打新',
    },
    advantage3: {
      text_1: '融资利率低',
      text_2: '可融资认购',
      text_3: '年利率低至1.88%',
      text_4: '最高20倍融资杠杆助力打新'
    },
    advantage4: {
      text_1: '赚钱效应',
      text_2: '截至2021年1月至11月3日',
      text_3: '默认每只新股都认购',
      text_4: '累计权益收益率约81%'
    },
    advantage5: {
      text_1: '暗盘交易',
      text_2: '可于新股上市前一个交易日',
      text_3: '收盘后暗盘时段买卖该股票'
    },
    advantage6: {
      text_1: '独角兽红利',
      text_2: '独角兽企业上市后受到',
      text_3: '资本市场热捧',
      text_4: '如：快手-W首日一手约赚1.9万港币'
    },
    phone: '更多问题，请致电官方客服：400-688-3187'
  },
  how_to_invest:{
    title:'为什么投资港美股？',
    title1:'投资全球顶尖港美上市公司',
    title2:'时间会凸显好公司的价值， 就像巴菲特一样，持有并留住好公司。',
    listTitle:'完善的市场和监管体系',
    ul:{
      li1:{
        t1:'交易市场透明化',
        t2:'港美股市场制度规范透明，投资者权益保障更完善'
      },
      li2:{
        t1:'T+0 交易',
        t2:'可日内买卖，交易更灵活'
      },
      li3:{
        t1:'丰富的投资品种',
        t2:'股票、ETF、基金及衍生品'
      },
      li4:{
        t1:'融资方便，可卖空交易',
        t2:'融资门槛低，可结合衍生品实现做空'
      }
    }
  },
  account_security_old: {
    title: '关于账户安全',
    title1: '遵循监管合规经营',
    title2: '让您放心完成每笔交易',
    content1: {
      desc1: {
        text_1: '持牌券商',
        text_2: '香港联合交易所及结算所参与者',
        text_3: '持牌券商(中央编号：AAW177)',
      },
      desc2: {
        text_1: '独立托管',
        text_2: '客户资金独立托管在中国银行(香港)',
        text_3: '客户证券资产托管在中央结算机构',
      },
      desc3: {
        text_1: '品牌积淀',
        text_2: '1989年创立于中国香港',
        text_3: '拥有超过32年的行业积淀',
      },
      desc4: {
        text_1: '数据加密',
        text_2: '采用银行级高度加密技术保障',
        text_3: '分布式数据中心 确保客户资产及信息安全',
      },
      desc5: {
        text_1: '保险保障',
        text_2: '港股受香港投资者赔偿基金(ICF)保护',
        text_3: '提供50万港币保障',
      },
    },
    title3: '荣获多项业界奖项',
    content3: {
      desc1: {
        text_1: '最佳互联网创新券商',
        text_2: '智通财经颁发'
      },
      desc2: {
        text_1: '优秀港资券商APP',
        text_2: '证券时报 券商中国 颁发'
      },
      desc3: {
        text_1: '创新内地市场服务信息商',
        text_2: '港交所颁发'
      },
      desc4: {
        text_1: '最佳综合服务奖',
        text_2: '凤凰网财经颁发'
      }
    },
    phone: '更多问题，请致电官方客服：400-688-3187'
  },
  account_security:{
    title:'账户安全保障',
    title1:'我们视客户的资金安全高于一切',
    ul:{
      li1:{
        t1:'持牌券商',
        t2:'Meta Stock PTY LTD是注册在澳大利亚的证券公司，由澳大利亚证券和投资委员会（ASIC）许可和监管，商业登记号：17656191847。',
        t3:'元宇证券是香港证监会持牌法团（持牌编号： AAW177）, 持有1/4/5/9号业务牌照资质,正在申请香港2/6/7号牌照。集团正在获取澳大利亚AFSL Licence、新加坡CMS license以及美国SEC Broker-Dealer。'
      },
      li2:{
        t1:'客户资产合规托管',
        t2:'客户资产以托管形式持有和保管，不接受任何第三方出入金，每交易日进行资产计算、确认和对账。',
        t3:'客户资产以托管形式持有和保管，不接受任何第三方出入金，每交易日进行资产计算、确认和对账。'
      },
      li3:{
        t1:'客户账户严格监管',
        t2:'客户账户定期严格审查及内外审计，均遵循当地监管机构要求严格监管。',
        t3:'客户账户定期严格审查及内外审计，均遵循当地监管机构要求严格监管。'
      },
    }
  },
  why_choose_us_old: {
    title: '为何选择我们',
    title1: '开户省心，交易安心',
    content1: {
      desc1: {
        text_1: '交易放心',
        text_2: '香港证监会监管的持牌券商',
        text_3: '(中央编号：AAW177)',
      },
      desc2: {
        text_1: '资金安心',
        text_2: '资金/资产第三方独立托管 严格监管保障',
      },
      desc3: {
        text_1: '开户省心',
        text_2: '线上2分钟极速开户 一个账户 投资全球',
      },
      desc4: {
        text_1: '入金顺心',
        text_2: '支持FPS/e-DDA/银证 多种极速入金方式',
      },
      desc5: {
        text_1: '福利动心',
        text_2: '开户即送优质股 更多福利无上限',
      },
      desc6: {
        text_1: '服务贴心',
        text_2: '客户满意为导向 专业答疑 贴心服务',
      }
    },
    phone: '更多问题，请致电官方客服：400-688-3187'
  },
  why_choose_us: {
    title:'为什么选择我们？',
    title_intro:'元宇证券，尽享优质投资服务',
    ul:{
      li1:{
        t1:'一个账户，投资全球',
        t2:'一站式港/美股 、沪/深股通交易平台，让您投资更便捷更高效',
      },
      li2:{
        t1:'丰富投资选择',
        t2:'美股正股、港股正股、A股正股、ETF 、 REITs、港股窝轮权证，更多的金融产品即将上线',
      },
      li3:{
        t1:'元宇研究院',
        t2:'权威发布海量元宇宙主题研报，助您更好的应对海外投资市场',
      },
      li4:{
        t1:'3V1尊享服务',
        t2:'3V1 VIP服务，为您的投资之路保驾护航',
      }
    },
    concat:'更多问题请联系客服'
  },
  how_the_gold_old: {
    title: '如何存入资金',
    title1: '存入资金，只需三步',
    content1: {
      desc1: {
        text_1: '准备银行卡 选择入金方式',
        text_2: '支持FPS/e-DDA/银证等多种入金方式',
      },
      desc2: {
        text_1: '汇款至证券账户',
        text_2: '提交审核',
      },
      desc3: {
        text_1: '查看收款信息',
        text_2: '最快5分钟到账',
      }
    },
    phone1: '更多详情，请在APP中依次点击「消息」-「帮助中心」查看',
    phone2: '或致电官方客服 400-688-3187'
  },
  how_the_gold:{
    title:'如何存入资金',
    title1:'入金快速到账',
    title2:'存入资金，只需三步',
    ul:{
      li1:{
        t1:'查看收款银行信息',
        t2:'打开App，根据存款指引，查看收款银行的具体信息。',
      },
      li2:{
        t1:'汇款至收款银行账户',
        t2:'在App中提交转账信息供系统审核',
      },
      li3:{
        t1:'查看收款信息',
        t2:'最快5分钟到账',
      },
    },
  },
  introduction_hk: {
    title: '港股入门',
    title1: '挖掘股票市场价值洼地',
    content1: {
      text_1: '港股',
      text_2: '，是指',
      text_3: '在香港联合交易所上市的股票',
      text_4: '。香港的股票市场比内地的成熟、理性，对世界的行情反映灵敏。通常，同一家公司的股票在港股市场估值较低，价格会比A股更便宜一些，所以港股历来被称为“价值洼地”。'
    },
    title2: '港股的市场结构',
    content2: {
      text_1: '香港上市公司来源于全球26个不同的国家和地区，香港交易所的股票市场分为主板和创业板，主板上市比创业板严格很多。',
      text_2: '港股市场主要的三类股票有：',
      text_3: '蓝筹股、红筹股和国企股',
      text_4: '蓝筹股',
      text_5: '这类股份的普遍特性是具有行业代表性、流通量高、财务状况良好、盈利稳定及派息固定。(对应的为恒生指数HSI)',
      text_6: '红筹股',
      text_7: '是指那些注册地在海外但在联交所上市，由中资企业直接控制或持有三成半股权以上的上市公司股份。(对应指数为红筹指数HSCCI)',
      text_8: '国企股',
      text_9: '指那些获中国证监会批核到香港上市的中国大陆的国有企业。它亦可称为 H 股，意指注册地在中国大陆，在联交所上市。(对应的指数为恒生国企指数HSCEI)',
      text_10: '区分红筹和国企股的标准在于注册地，在海外注册的就是红筹股，在内地注册的自然是国企股。'
    },
    title3: '港股指数介绍',
    content3: {
      desc1: '恒生指数',
      text_1: '也是通常所说的',
      text_2: '大盘指数',
      text_3: '是以香港股票市场中的50家上市股票为成份股样本，以其发行量为权数的加权平均股价指数，是反映香港股市价幅动趋势最有影响的一种股价指数。',
      desc2: '恒生中国企业指数',
      text_4: '反映了在香港交易所上市的H股中较大型股的表现，与恒生指数不同，国企指数成份股的数目并没有限制，但必须为',
      text_5: '市值最大，且在恒生综合指数成份股内的H股',
      desc3: '红筹指数',
      text_6: '主要由',
      text_7: '25只市值较大，交易活跃，具有行业代表性的红筹股',
      text_8: '组成。分布的行业主要包括石油化工、房地产、港口运输、汽车、科技及综合类等。'
    },
    title4: '港股和A股的不同',
    content4: {
      desc1: '交易时间不同',
      text_1: 'A股的交易时间是工作日上午9:00-11:30，下午1:00到3:00；港股的交易时间比A股更长，上午从',
      text_2: '9:00-12:00',
      text_3: '，下午',
      text_4: '从1:00-4:00',
      text_5: '。算下来港股每天的交易时间比A股长一个半小时。',
      desc2: '交易与交收机制不同',
      text_6: 'A股实行T+1交易，也就是说当天买入的股票第二天才能卖出。港股实行',
      text_7: 'T+0回转交易',
      text_8: '，当天买入的股票可以在当天卖出，并且不限次数，短线盈利空间更大。',
      text_9: '就交收制度而言，A股实行T+1，港股实行T+2，也就是说，如果周一卖出股票，所得资金可以用来买其他股票，但要提取现金就需要等到周三。',
      desc3: '交易单位不同',
      text_10: '港股交易单位也和A股有所差异，A股的一手=100股，而港股的一手可能是100股、500股、1000股，甚至是2000股，',
      text_11: '由上市公司自行决定',
      desc4: '交易品种不同',
      text_12: '港股经过上百年发展，交易品种非常丰富，有很多A股当前还没有的衍生品，比如',
      text_13: '窝轮、牛熊证、界内证',
      text_14: '等带有对冲功能的衍生工具。除此之外，港股还支持融资交易，而A股需要50万资金才能开通融资功能。同时港股支持做空，无论股市涨跌都有赚钱机会。'
    },
    phone1: '更多课堂内容，将陆续推出，敬请期待哦！',
    phone2: '或致电官方客服 400-688-3187'
  },
  introduction_usa: {
    title: '美股入门',
    title1: '投资全球顶尖公司',
    content1: {
      text_1: '美股',
      text_2: '，即美国股市。美国股票市场是',
      text_3: '规模最大、最开放的市场',
      text_4: '，各种制度完善，上市的公司基本上涵盖了美国乃至国际上全部著名、知名品牌的产品公司和企业。目前主要由道琼斯工业股票指数、纳斯达克指数和标准普尔500指数三大股指构成。'
    },
    title2: '美股交易市场',
    content2: {
      desc1: '纽约证券交易所',
      text_1: '纽约证券交易所是',
      text_2: '上市公司总市值第一，IPO数量及市值第一，交易量第二的交易所',
      text_3: '。至今已有二百多年历史，上市企业逾三千多家，其市场较成熟，上市要求较为严格。NYSE上市的主要是商业股，例如：美国商业银行 BAC。',
      desc2: '纳斯达克证券市场',
      text_4: '是一个基于电子网络的无形市场，是',
      text_5: '美国上市公司最多、股份交易量最大的证券市场',
      text_6: '。挂牌交易的公司已经近七千家，在此挂牌的公司多半是科技股。',
      desc3: '美国证券交易所',
      text_7: '现为美国第三大股票交易所，是',
      text_8: '唯一一家能同时进行股票、期权和衍生产品交易的交易所',
      text_9: '，也是唯一一家关注于易被人忽略的中小市值公司并为其提供一系列服务来增加其关注度的交易所。'
    },
    title3: '美股的三个主要指数',
    content3: {
      desc1: '道琼斯工业平均指数',
      text_1: '道琼斯指数是世界上历史最为悠久的股票指数，综合指数是由',
      text_2: '工业、交通运输、公共事业三个指数的65只成份股组成的平均指数',
      desc2: '纳斯达克指数',
      text_3: '纳斯达克综合指数是',
      text_4: '反映纳斯达克证券市场行情变化的股票价格平均指数',
      text_5: '，基本指数为100。',
      desc3: '标准普尔500指数',
      text_6: '由知名的评级公司标准普尔，根据市值及流通量，',
      text_7: '在美国股票市场内挑选出500家企业所组成的，以市值加权的股价指数',
      text_8: '。由于其成分股更多元化，能反映美股的价值。',
    },
    title4: '美股衍生品',
    content4: {
      desc1: '期权',
      text_1: '期权，是一种',
      text_2: '选择权',
      text_3: '，指一种',
      text_33: '能在未来某特定时间以特定价格买入或卖出一定数量的某种特定商品的权利',
      text_4: '。它是在期货基础上产生的一种金融工具，给予买方(或持有者)购买或出售标的资产的权利。',
      desc2: 'ADR',
      text_5: '美国',
      text_6: '存托凭证代表持有非美国公司股票',
      text_7: '的一种凭证，但投资者可在美股市场上交易。',
      desc3: 'ETF',
      text_8: 'ETF是一种',
      text_9: '跟踪市场指数、可以在证券交易所自由买卖的开放式股票基金',
      text_10: '。大家可以把ETF理解为一种特殊形式的共同基金：发行机构把不同的股票买来，汇合到一起形成共同基金，然后再分成一小块一小块拿到股市上卖，它们就成了可以自由买卖的ETF指数基金。你买一支ETF就相当于购买了这个指数的所有成份股。',
    },
    phone1: '更多课堂内容，将陆续推出，敬请期待哦！',
    phone2: '或致电官方客服 400-688-3187'
  },
  introduction_cn: {
    title: '中华通介绍',
    title1: '发现有潜力的成长性企业',
    content1: {
      text_1: '沪港通与深港通统称“中华通”',
      text_2: '，是一项互联互通机制，香港和国际投资者可以通过香港联合交易所有限公司(以下简称“香港联交所”)及其清算所交易并清算上海证券交易所(以下简称“上交所”)和深圳证券交易所(以下简称“深交所”)的上市股票。',
      text_3: '上交所/深交所有不同类型的挂牌证券，但沪港通和深港通目前阶段只能交易A股(在中国证券交易所交易的大陆公司股票)。',
      text_4: '沪股通',
      text_5: '股票包括所有上证180指数与上证380指数的成分股，以及不在上述指数成份股内但有H股同时在联交所上市及买卖的上交所A股。',
      text_6: '深港通',
      text_7: '股票包括深证成份指数和深证中小创新指数成份股中所有市值不少于60亿元人民币的成份股，以及有相关H股在联交所上市的所有深交所上市A股。'
    },
    title2: '中华通北向交易特性',
    content2: {
      desc1: '沪港通',
      text_1: '·上证180指数及上证380指数成份股',
      text_2: '· A+H挂牌之A股',
      text_3: '·不包括不以人民币交易的沪股',
      text_4: '·不包括被实施风险警示的沪股',
      desc2: '深港通',
      text_5: '·深证成份指数及深证中小创新指数成分股',
      text_6: '·市值60亿元人民币以上的深证成分指数及深证中小创新指数成分股',
      text_7: '·A+H挂牌之A股',
      text_8: '·不包括不以人民币交易的深股',
      text_9: '·不包括被实施风险警示的深股'
    },
    phone1: '更多课堂内容，将陆续推出，敬请期待哦！',
    phone2: '或致电官方客服 400-688-3187'
  },
  account_manager: {
    title: '我的客户经理',
    txt_1: '您好，我是您的',
    txt_2: '专属客户经理',
    txt_3: '{petName} {name}，请添加我的企业微信，享受至尊VIP服务',
    txt_4: '微信扫码添加',
    txt_5: '©2023 元宇证券有限公司版权所有',
    qr_txt_1: '复制成功',
    qr_txt_2: '该浏览器不支持，请手动复制',
  }
}